module.exports = __webpack_public_path__ + "static/media/defaultBranch.748c1343.png";